/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './request-support-button.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../app/modules/utilities/components/request-support/request-support-button.component';
import * as i3 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i4 from '@angular/material';
import * as i5 from '@angular/cdk/platform';
import * as i6 from '@angular/cdk/overlay';
import * as i7 from '@angular/cdk/scrolling';
import * as i8 from '@angular/cdk/bidi';
import * as i9 from '../../../../../../app/modules/utilities/services/request-support/request-support.service';
import * as i10 from '../../../../../../app/modules/utilities/services/confirmation-dialog/confirmation-dialog.service';
const styles_RequestSupportButtonComponent:any[] = [i0.styles];
export const RenderType_RequestSupportButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_RequestSupportButtonComponent,data:{}});
export function View_RequestSupportButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),10,'button',
      [['class','mat-mini-fab'],['md-mini-fab',''],['mdTooltip','Get Help']],[[8,'disabled',
          0]],[[(null as any),'click'],[(null as any),'longpress'],[(null as any),
          'touchend']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.RequestSupportButtonComponent = _v.component;
        if (('longpress' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,4).show()) !== false);
          ad = (pd_0 && ad);
        }
        if (('touchend' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,4).hide(1500)) !== false);
          ad = (pd_1 && ad);
        }
        if (('click' === en)) {
          const pd_2:any = ((<any>_co.openDialog()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i3.View_MdButton_0,i3.RenderType_MdButton)),i1.ɵdid(1,16384,(null as any),
      0,i4.MdPrefixRejector,[[2,i4.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,180224,(null as any),0,i4.MdButton,[i1.Renderer2,i1.ElementRef,
      i5.Platform,i4.FocusOriginMonitor],(null as any),(null as any)),i1.ɵdid(3,16384,
      (null as any),0,i4.MdMiniFab,[[2,i4.MdButton],[8,(null as any)]],(null as any),
      (null as any)),i1.ɵdid(4,147456,(null as any),0,i4.MdTooltip,[i6.Overlay,i1.ElementRef,
      i7.ScrollDispatcher,i1.ViewContainerRef,i1.NgZone,i1.Renderer2,i5.Platform,i4.MD_TOOLTIP_SCROLL_STRATEGY,
      [2,i8.Directionality]],{message:[0,'message']},(null as any)),(_l()(),i1.ɵted(-1,
      0,['\n  '])),(_l()(),i1.ɵeld(6,0,(null as any),0,3,'md-icon',[['class','mat-icon'],
      ['role','img']],(null as any),(null as any),(null as any),i3.View_MdIcon_0,i3.RenderType_MdIcon)),
      i1.ɵdid(7,16384,(null as any),0,i4.MdPrefixRejector,[[2,i4.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(8,638976,(null as any),
          0,i4.MdIcon,[i1.Renderer2,i1.ElementRef,i4.MdIconRegistry,[8,(null as any)]],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['live_help'])),(_l()(),
          i1.ɵted(-1,0,['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n\n']))],(_ck,
      _v) => {
    const currVal_1:any = 'Get Help';
    _ck(_v,4,0,currVal_1);
    _ck(_v,8,0);
  },(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
  });
}
export function View_RequestSupportButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-request-support-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_RequestSupportButtonComponent_0,
      RenderType_RequestSupportButtonComponent)),i1.ɵdid(1,49152,(null as any),0,i2.RequestSupportButtonComponent,
      [i4.MdDialog,i9.RequestSupportService,i10.ConfirmationDialogService],(null as any),
      (null as any))],(null as any),(null as any));
}
export const RequestSupportButtonComponentNgFactory:i1.ComponentFactory<i2.RequestSupportButtonComponent> = i1.ɵccf('app-request-support-button',
    i2.RequestSupportButtonComponent,View_RequestSupportButtonComponent_Host_0,{},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL3JlcXVlc3Qtc3VwcG9ydC9yZXF1ZXN0LXN1cHBvcnQtYnV0dG9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy91dGlsaXRpZXMvY29tcG9uZW50cy9yZXF1ZXN0LXN1cHBvcnQvcmVxdWVzdC1zdXBwb3J0LWJ1dHRvbi5jb21wb25lbnQudHMiLCJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy91dGlsaXRpZXMvY29tcG9uZW50cy9yZXF1ZXN0LXN1cHBvcnQvcmVxdWVzdC1zdXBwb3J0LWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL3JlcXVlc3Qtc3VwcG9ydC9yZXF1ZXN0LXN1cHBvcnQtYnV0dG9uLmNvbXBvbmVudC50cy5SZXF1ZXN0U3VwcG9ydEJ1dHRvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxidXR0b24gbWQtbWluaS1mYWIgKGNsaWNrKT1cIm9wZW5EaWFsb2coKVwiIG1kVG9vbHRpcD1cIkdldCBIZWxwXCI+XG4gIDxtZC1pY29uPmxpdmVfaGVscDwvbWQtaWNvbj5cbjwvYnV0dG9uPlxuXG4iLCI8YXBwLXJlcXVlc3Qtc3VwcG9ydC1idXR0b24+PC9hcHAtcmVxdWVzdC1zdXBwb3J0LWJ1dHRvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQW9CO1VBQUE7VUFBQTtRQUFBO1FBQXBCO01BQUEscURBQUE7TUFBQTtNQUFBLHNCQUFBO3VDQUFBLHNDQUFBO01BQUE7TUFBQSxzQkFBQTs7TUFBQSw4REFBZ0U7TUFBQSxhQUM5RDtNQUFBO2FBQUE7dUJBQUEsc0NBQUE7VUFBQTtVQUFBLDZCQUFTLHFDQUFtQjtpQkFBQSxlQUNyQjs7SUFGa0M7SUFBM0MsV0FBMkMsU0FBM0M7SUFDRTs7SUFERjtJQUFBLFdBQUEsU0FBQTs7OztvQkNBQTtNQUFBOzhDQUFBLFVBQUE7TUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/utilities/components/request-support/request-support-button.component.ngfactory.ts